module.exports = {"pageTitleText":"RecordLineGroups","recordLineGroupName":"Name","createText":"Add RecordLineGroup"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/recordLineGroups.json
// module id = AqzK
// module chunks = 3